import {getColors} from '../../utils/styles';

const colors = getColors();

export const ResendIcon = ({color = colors.charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;

  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  const colorValue = colors[color] || color;

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 28.566406 14.792969 L 5.902344 4.125 C 5.671875 4.019531 5.417969 3.976562 5.167969 4.007812 C 4.917969 4.039062 4.679688 4.140625 4.484375 4.300781 C 4.289062 4.460938 4.144531 4.675781 4.066406 4.914062 C 3.988281 5.152344 3.976562 5.410156 4.039062 5.65625 L 6.625 16 L 4.039062 26.34375 C 3.976562 26.589844 3.988281 26.847656 4.066406 27.085938 C 4.144531 27.328125 4.289062 27.539062 4.484375 27.699219 C 4.679688 27.859375 4.917969 27.960938 5.167969 27.992188 C 5.417969 28.023438 5.671875 27.980469 5.902344 27.875 L 28.566406 17.207031 C 28.796875 17.097656 28.992188 16.929688 29.125 16.714844 C 29.261719 16.5 29.335938 16.253906 29.335938 16 C 29.335938 15.746094 29.261719 15.5 29.125 15.285156 C 28.992188 15.070312 28.796875 14.902344 28.566406 14.792969 Z M 7.308594 24.261719 L 8.425781 19.785156 L 16 16 L 8.425781 12.214844 L 7.308594 7.738281 L 24.867188 16 Z M 7.308594 24.261719 "
        fill={colorValue}
      />
    </svg>
  );
};
